export const GET_BRITANIA_DETAILS = 'getBritaniaDetail';
export const GET_I_BOOKING = 'getIBooking';
